import { useState } from "react";

import { DefaultButton, Heading, Stack, Text, useTheme } from "@bps/fluent-ui";
import { DeploymentDetail } from "@libs/api/gateways/field/field-ops-gateway.dtos";

import { DeploymentDetailTimeline } from "./DeploymentDetailTimeline";

interface DeploymentDetailSectionProps {
  detail: DeploymentDetail;
}

export const DeploymentDetailSection: React.FC<DeploymentDetailSectionProps> = ({
  detail
}) => {
  const theme = useTheme();

  const [renderKey, setRenderKey] = useState(0);

  const [fitZoom, setFitZoom] = useState(false);

  const handleResetTimeline = () => {
    setFitZoom(false);
    setRenderKey(renderKey + 1);
  };

  const handleFitZoom = () => {
    setFitZoom(true);
    setRenderKey(renderKey + 1);
  };

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      <Stack
        horizontal
        horizontalAlign="space-between"
        verticalAlign="center"
        tokens={{ childrenGap: theme.spacing.m }}
      >
        <Heading variant="section-heading">Rollouts Timeline</Heading>

        {detail.deploymentRings.length > 0 && (
          <>
            <Stack.Item align="center">
              <Text variant="small">
                Click and drag to pan timeline. Click header rows or Ctrl+Mouse
                wheel to zoom in or out. Click a rollout to navigate to the
                rollout edit page.
              </Text>
            </Stack.Item>
            <Stack.Item align="end">
              <Stack horizontal tokens={{ childrenGap: theme.spacing.s2 }}>
                <DefaultButton onClick={handleFitZoom}>Fit Zoom</DefaultButton>
                <DefaultButton onClick={handleResetTimeline}>
                  Reset Zoom
                </DefaultButton>
              </Stack>
            </Stack.Item>
          </>
        )}
      </Stack>
      <DeploymentDetailTimeline
        detail={detail}
        key={renderKey}
        fitZoom={fitZoom}
      />
    </Stack>
  );
};
